/* أدوات سنيبتات Tabby الرسمية — مفاتيح عامة فقط (لا أسرار بالواجهة) */
export const TABBY_PK = process.env.REACT_APP_TABBY_PUBLIC_KEY || "";
export const TABBY_MC = process.env.REACT_APP_TABBY_MERCHANT_CODE || "";

const loaded = {};
export function loadTabbyScript(src) {
  if (!loaded[src]) {
    loaded[src] = new Promise((resolve) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        if (existing.dataset.tabbyLoaded) { resolve(); return; }
        existing.addEventListener("load", () => resolve());
        existing.addEventListener("error", () => resolve());
        return;
      }
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = () => { s.dataset.tabbyLoaded = "1"; resolve(); };
      s.onerror = () => resolve();
      document.body.appendChild(s);
    });
  }
  return loaded[src];
}
